export { default as comisions } from './comisions-table.vue';


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/table/index.js
// module id = ./src/components/shared/table/index.js
// module chunks = 34